import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'

interface IRatingProps {
  rating: number
}

const STAR_STEP = 50
const STAR_CENTER_X = 22
const STAR_POINTS =
  '22,3 28.17,16.51 42.92,18.2 31.99,28.24 34.93,42.8 22,35.5 9.07,42.8 12.01,28.24 1.08,18.2 15.83,16.51'

const Rating = ({ rating }: IRatingProps) => {
  const decimal = Math.round((rating % 1) * 10) / 10
  const fullStars = Math.floor(rating)
  const finalFullStars = decimal >= 0.8 ? fullStars + 1 : fullStars
  const hasHalfStar = decimal >= 0.3 && decimal <= 0.7
  const total: number[] = Array.from(Array(5), () => 0)
  const fillColor = '#023b7f'
  const emptyColor = '#dcdcdc'

  return (
    <EmptyLink color="#1860ae">
      <svg preserveAspectRatio="xMinYMin meet" viewBox="0 0 244 50" style={{ width: '103px', height: '21px' }}>
        {total.map((_, index) => (
          <g key={index} transform={`translate(${index * STAR_STEP}, 0)`}>
            <polygon fill={emptyColor} points={STAR_POINTS} />
            {index < finalFullStars && <polygon fill={fillColor} points={STAR_POINTS} />}
            {index === fullStars && hasHalfStar && (
              <clipPath id={`krogerHalfStar-${index}`}>
                <rect x="0" y="0" width={STAR_CENTER_X} height="50" />
              </clipPath>
            )}
            {index === fullStars && hasHalfStar && (
              <polygon fill={fillColor} points={STAR_POINTS} clipPath={`url(#krogerHalfStar-${index})`} />
            )}
          </g>
        ))}
      </svg>
    </EmptyLink>
  )
}

export default Rating
